export const ALLOWED_FILE_TYPES = ['image/png', 'image/jpeg', 'image/heic', 'image/heif']
